import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, List, ListItem, Typography, ListItemText } from '@material-ui/core';
import { useStyles, listTextStyles, customCardStyles } from './PromoCodeAccounting.styled';
import { withRouter } from 'react-router-dom';
import { UpdateAccounting } from 'components/Modals/PromoCodes';
import { Card } from 'components/UI';
import i18n from 'i18n-js';
import { PricingActions } from 'state/modules/pricing';

const PromoCodeAccounting = ({ id, promoCode }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const listClasses = listTextStyles();
  const cardClasses = customCardStyles();
  const [openAccountingModal, setOpenAccountingModal] = useState(false);
  const { adhoc } = useSelector((state) => state.pricing);

  useEffect(() => {
    if (id) {
      dispatch(PricingActions.fetchAdHocTypesById(id));
    }
  }, [id]) // eslint-disable-line

  const handleOpenEditAccountingModal = () => {
    setOpenAccountingModal((prevState) => !prevState);
  };
  /**
   * Vertical menu list
   * It has the label and the function for each action
   */
  const items = [
    {
      title: i18n.t('promo_codes.edit_accounting'),
      onClick: handleOpenEditAccountingModal,
    },
  ];

  return (
    <Card
      menuItems={items}
      menuPermissions={{
        action: 'update',
        subject: 'promotional_code',
        type: 'can',
      }}
      title={i18n.t('promo_codes.accounting')}
      headerActionType="vertical"
      contentRootClasses={cardClasses}
    >
      <Box className={classes.cardContentPadding}>
        <List className={classes.accountingList}>
          <ListItem className={classes.accountingListItem}>
            <ListItemText
              classes={{
                root: listClasses.root,
                primary: listClasses.primary,
                secondary: listClasses.secondary,
              }}
              primary={`${i18n.t(`promo_codes.credit_type`)}:`}
              secondary={
                <Box
                  display="flex"
                  component="span"
                  flexDirection="column"
                  className={classes.textRight}
                >
                  <Typography variant="body2" component="span" color="textSecondary">
                    {adhoc?.name}
                  </Typography>
                </Box>
              }
            />
          </ListItem>
        </List>
      </Box>
      {openAccountingModal && (
        <UpdateAccounting
          id={id}
          promoCode={promoCode}
          open={openAccountingModal}
          handleClick={handleOpenEditAccountingModal}
        />
      )}
    </Card>
  );
};

export default withRouter(PromoCodeAccounting);
